import { createAsyncTypes } from 'utils/ActionCreator'
import { capitalizeFirstLetter as cfl } from 'utils/helpers'

const typeKey = 'AwarenessCenter'

export const SUBMIT_UPSELL_SEEN_INDICATION = createAsyncTypes(
  'SUBMIT_UPSELL_SEEN_INDICATION',
  typeKey
)

export const FETCH_CAMPAIGNS_SETTINGS = createAsyncTypes('FETCH_CAMPAIGNS_SETTINGS', typeKey)

export const SP_GENERATION_POLLING_ASYNC = createAsyncTypes('SP_GENERATION_POLLING_ASYNC', typeKey)

export const SCENARIO_TYPE_VALUES = {
  DRIVE_BY: 0,
  ATTACHMENT: 1,
  CALL_FOR_ACTION: 2,
  SMISHING: 3,
}

export const SCENARIO_TYPE_OPTIONS = [
  { value: SCENARIO_TYPE_VALUES.DRIVE_BY, label: 'Drive-by' },
  { value: SCENARIO_TYPE_VALUES.ATTACHMENT, label: 'Attachment' },
  { value: SCENARIO_TYPE_VALUES.CALL_FOR_ACTION, label: 'Call To Action' },
  // { value: SCENARIO_TYPE_VALUES.SMISHING, label: 'Smishing' },
]

export const CAMPAIGN_TYPES = {
  SIMULATION: 'simulation',
  TRAINING: 'training',
  SPEAR_PHISHING: 'spear-phishing',
}

export const CAMPAIGN_TYPES_VALUES = {
  TRAINING: 1,
  SIMULATION: 2,
  SPEAR_PHISHING: 3,
  AUTONOMOUS_CAMPAIGN: 4,
}

export const MAP_LABEL_BY_CAMPAIGN_TYPES = {
  [CAMPAIGN_TYPES.SIMULATION]: 'Phishing Simulation',
  [CAMPAIGN_TYPES.TRAINING]: 'Awareness Training',
  [CAMPAIGN_TYPES.SPEAR_PHISHING]: 'Spear Phishing',
}

export const CAMPAIGN_TYPES_KEYS = {
  1: CAMPAIGN_TYPES.TRAINING,
  2: CAMPAIGN_TYPES.SIMULATION,
  3: CAMPAIGN_TYPES.SPEAR_PHISHING,
}

export const MAP_VALUE_BY_CAMPAIGN_TYPE = {
  [CAMPAIGN_TYPES.SIMULATION]: CAMPAIGN_TYPES_VALUES.SIMULATION,
  [CAMPAIGN_TYPES.TRAINING]: CAMPAIGN_TYPES_VALUES.TRAINING,
  [CAMPAIGN_TYPES.SPEAR_PHISHING]: CAMPAIGN_TYPES_VALUES.SPEAR_PHISHING,
}

export const CAMPAIGN_TYPES_OPTIONS = [
  {
    label: cfl(CAMPAIGN_TYPES.SIMULATION),
    value: CAMPAIGN_TYPES_VALUES.SIMULATION,
  },
  {
    label: cfl(CAMPAIGN_TYPES.TRAINING),
    value: CAMPAIGN_TYPES_VALUES.TRAINING,
  },
  {
    label: cfl(CAMPAIGN_TYPES.SPEAR_PHISHING),
    value: CAMPAIGN_TYPES_VALUES.SPEAR_PHISHING,
  },
]

export const CAMPAIGN_NOTIFICATION_TYPE = {
  CAMPAIGN_FAILED: 1,
}

export const wizardEntities = {
  [CAMPAIGN_TYPES.SIMULATION]: 'wizardSimulationCampaign',
  [CAMPAIGN_TYPES.TRAINING]: 'wizardTrainingCampaign',
  [CAMPAIGN_TYPES.SPEAR_PHISHING]: 'wizardSpearPhishingCampaign',
}

export const FROM_EMAIL = 'training@ironscales.com'

export const SEND_REMINDER_EVERY_X_BUSINESS_DAYS_VALUES = {
  NOT_CHECKED: 0,
  CHECKED: 2,
}

export const createWizardCampaignSelector = (state) => {
  if (state.awarenessCenter.wizardTrainingCampaign) {
    return state.awarenessCenter[wizardEntities[CAMPAIGN_TYPES.TRAINING]]
  } else if (state.awarenessCenter.wizardSpearPhishingCampaign) {
    return state.awarenessCenter[wizardEntities[CAMPAIGN_TYPES.SPEAR_PHISHING]]
  } else {
    return state.awarenessCenter[wizardEntities[CAMPAIGN_TYPES.SIMULATION]]
  }
}

export const getCampaignTypeByState = (state) => {
  if (state.awarenessCenter.wizardTrainingCampaign) {
    return CAMPAIGN_TYPES.TRAINING
  } else if (state.awarenessCenter.wizardSpearPhishingCampaign) {
    return CAMPAIGN_TYPES.SPEAR_PHISHING
  } else {
    return CAMPAIGN_TYPES.SIMULATION
  }
}

export const BANNED_WORDS_ERROR = 'BANNED_WORDS_ERROR'

export const SHARED_MAILBOX = 'Shared_Mailbox'

export const DELIVERY = {
  EMAIL: 0,
  SMS: 1,
}

export const LEVEL_VALUES = {
  BEGINNER_LEVEL: 0,
  MID_LEVEL: 1,
  EXPERT_LEVEL: 2,
  ALL_LEVELS: 3,
}

export const PARTICIPANTS_PER_PAGE = 7

export const PARTICIPANTS_EXCLUDE_FILTER_VALUES = {
  ALL: 0,
  EXCLUDED: 1,
  INCLUDED: 2,
  GENERATED: 3,
  IN_PROGRESS: 4,
  FAILED: 5,
}

export const PARTICIPANTS_EXCLUDE_FILTER_KEYS_BY_VALUES = {
  [PARTICIPANTS_EXCLUDE_FILTER_VALUES.ALL]: 'All',
  [PARTICIPANTS_EXCLUDE_FILTER_VALUES.EXCLUDED]: 'EXCLUDED',
  [PARTICIPANTS_EXCLUDE_FILTER_VALUES.INCLUDED]: 'INCLUDED',
  [PARTICIPANTS_EXCLUDE_FILTER_VALUES.GENERATED]: 'SUCCESS',
  [PARTICIPANTS_EXCLUDE_FILTER_VALUES.IN_PROGRESS]: 'IN_PROGRESS',
  [PARTICIPANTS_EXCLUDE_FILTER_VALUES.FAILED]: 'FAILED',
}

export const PARTICIPANTS_GROUP_KEYS = {
  INCLUDED: 'included',
  EXCLUDED: 'excluded',
}

export const PARTICIPANTS_GROUP_OPTIONS = [
  {
    label: 'All',
    value: PARTICIPANTS_EXCLUDE_FILTER_VALUES.ALL,
  },
  {
    label: 'Include',
    value: PARTICIPANTS_EXCLUDE_FILTER_VALUES.INCLUDED,
  },
  {
    label: 'Exclude',
    value: PARTICIPANTS_EXCLUDE_FILTER_VALUES.EXCLUDED,
  },
]

export const SPEAR_PHISHING_PARTICIPANTS_GROUP_OPTIONS = [
  {
    label: 'All',
    value: PARTICIPANTS_EXCLUDE_FILTER_VALUES.ALL,
  },
  {
    label: 'Generated',
    value: PARTICIPANTS_EXCLUDE_FILTER_VALUES.GENERATED,
  },
  {
    label: 'In progress',
    value: PARTICIPANTS_EXCLUDE_FILTER_VALUES.IN_PROGRESS,
  },
  {
    label: 'Failed',
    value: PARTICIPANTS_EXCLUDE_FILTER_VALUES.FAILED,
  },
]

export const PARTICIPANTS_NAMES_CATEGORY = 'Names'
export const PARTICIPANTS_ALL_CATEGORY = 'All Company'
export const DEFAULT_MANAGER_REPORT_REMINDERS_THRESHOLD = 3
export const DEFAULT_MANAGER_REPORT_DAY_OF_WEEK = 0
